import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"

import Overview from "../pages/Home/Overview"
import Signup from "../pages/Home/Signup"
import Login from "../pages/Home/Login"
import RequestRecovery from "../pages/Home/RequestRecovery"
import ResetPassword from "../pages/Home/ResetPassword"
import Download from "../pages/Home/Download"

const homeRoutes = () => (
	<Switch>
		<Route exact path="/:hash" component={Overview} />
		<Route exact path="/:hash/signup" component={Signup} />
		<Route exact path="/:hash/login" component={Login} />
		<Route exact path="/:hash/request-recovery" component={RequestRecovery} />
		<Route exact path="/:hash/reset-password" component={ResetPassword} />
		<Route exact path="/:hash/download" component={Download} />
	</Switch>
)

export default withRouter(homeRoutes)
